import React from "react";
import { connect } from "react-redux";
import { Modal, Button, Row } from "react-bootstrap";
import { alertActions } from "../../../store/actions/AlertActions";
import { deleteProcessStatus } from "../../../services/RequestService";
import "../../../pages/settings/process/SettingsProcessPage.css";
import { Col } from "react-bootstrap";

function ModalProcessStatusDelete({ show, onHide, processStatus, onAddAlert }) {
  const [loading, setLoading] = React.useState(false);

  function confirmRemove() {
    setLoading(true);
    deleteProcessStatus({ id: processStatus.id })
      .then((res) => {
        console.log(res);
        if (res.ok) {
          onAddAlert("Status de processo removido com sucesso.", "success");
          onHide(true);
        } else {
          onAddAlert(res.data.log, "danger");
          onHide(true);
        }
      })
      .catch((e) => {
        onAddAlert("Ocorreu um erro ao tentar remover o status de processo.", "danger");
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Remoção de Status de Processo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Você tem certeza que deseja excluir o Status de Processo: {processStatus.name}?</p>
      </Modal.Body>
      <Modal.Footer className="p-0">
        <Row className="w-100 m-0">
          <Col className=" p-0">
            <Button
              variant="secondary"
              className="w-100 button-without-rounded"
              onClick={() => onHide()}
            >
              Voltar
            </Button>
          </Col>
          <Col className="p-0">
            <Button
              variant="danger"
              className="w-100 button-without-rounded"
              disabled={loading}
              onClick={confirmRemove}
            >
              Remover
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddAlert: (text, prcessStatus, alertPriority) =>
      dispatch(alertActions.addAlert(text, prcessStatus, alertPriority)),
  };
};

export default connect(null, mapDispatchToProps)(ModalProcessStatusDelete);
